import { DivNumberInput } from "@/components/DivInput/DivNumberInput"
import { LabelRow } from "./LabelRow"
import { ManualObject } from "@/services/project/modal"
import {isObject, isNumber} from 'lodash-es'
import styles from './styles.module.less'
import { useMemo } from "react"
import { AppDispatch } from "@/store"
import { useDispatch, useSelector } from "react-redux"
import { addManualInputThunk, deleteManualInputThunk } from "@/store/flowsheet/actions"
import { toDefaultUnitVal, toUnitVal, toUnitValStrWithFormat } from "./utils"
import { RunState, getFlowSimulationSelector, getStatus } from "@/store/flowsheet/flowsheet.slice"
import { getActiveUnitSet } from "@/store/project/selector"

export interface ManualInputRowProps {
  label: string
  data: number | ManualObject
  attrKey: string
  unitId: string
  dimCode?: string
  reload?: () => void
}
export const ManualInputRow = (props: ManualInputRowProps) => {
  const {data, label, attrKey, unitId, dimCode} = props
  const flowSimulation = useSelector(getFlowSimulationSelector)
  const unitSet = useSelector(getActiveUnitSet)
  const status = useSelector(getStatus)
  const dispatch = useDispatch<AppDispatch>()

  const varUnitData = useMemo(() => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [unitSet, dimCode])

  const unitString = varUnitData?.unit.code


  const onChange = async (value: number) => {
    if (!flowSimulation) return;
    dispatch(addManualInputThunk({
      data: {dvars: [{unitId, attribute: attrKey, value: toDefaultUnitVal(value, varUnitData?.unit)}]},
      params: {sId: flowSimulation.id}
    }))
  }

  const onDelete = async () => {
    if (!flowSimulation) return;
    dispatch(deleteManualInputThunk({
      data: {dvars: [{unitId, attribute: attrKey, value: undefined}]},
      params: {sId: flowSimulation?.id}
    }))
  }

  const varLabel = `${label}[${unitString ?? '-'}]`

  if (status === RunState.Stop || isNumber(data)) {
    const val = isObject(data) ? (data as ManualObject).val : data
    return <LabelRow label={varLabel} value={isNumber(val) ? toUnitValStrWithFormat(val as number, varUnitData): val as number}/>
  }

  if (isObject(data)) {
    return <LabelRow
      className={styles.manualInputRow}
      label={varLabel}
      value={<DivNumberInput
        unitEntity={varUnitData}
        dimCode={dimCode}
        removeAble={true}
        value={toUnitVal((data as ManualObject).val, varUnitData?.unit)}
        onChange={onChange}
        onDelete={onDelete}
      />}
    />
  }

  return <LabelRow label={varLabel} value={
    <DivNumberInput
      unitEntity={varUnitData}
      dimCode={dimCode}
      value={toUnitVal(data as number, varUnitData?.unit)}
      onChange={onChange}/>}
    />
}